import { useEffect, useState } from 'react'
import { useLanguage } from '../context/LanguageProvider'

const arabicFonts = {
  header: 'BalooBhaijaan2-Medium',
  bodyHead: 'Montserrat-Arabic-Bold',
  body: 'Montserrat-Arabic-Medium',
  bodyNormal: 'Montserrat-Arabic-Light'
}

const englishFonts = {
  header: 'Hammersmith One',
  bodyHead: 'NotoSans-Bold',
  body: 'NotoSans-Medium',
  bodyNormal: 'NotoSans-Light'
}

const useFonts = () => {
  const { lang } = useLanguage()
  const [fonts, setFonts] = useState(englishFonts)

  useEffect(() => {
    if (lang && lang === 'ar') {
      setFonts(arabicFonts)
    } else {
      setFonts(englishFonts)
    }
  }, [lang])

  return { fonts }
}

export default useFonts
